import { useQuery } from '@tanstack/react-query'
import { resolvePlaceSearch } from 'tripPlanner/api'
import * as PlaceInfoKeys from 'tripPlanner/hooks/reactQueryKeys/placeInfo'

/**
 * Lazy Google Place resolve for hover previews (chat links + in-chat map pins).
 * Silently fails — demotion / snackbars belong to the click path
 * (`usePlaceSearchResolver`).
 */
function usePlaceSearchHoverResolve(
  searchQuery: string | undefined,
  enabled: boolean,
) {
  const trimmed = searchQuery?.trim() || undefined

  return useQuery({
    queryKey: PlaceInfoKeys.resolveSearch(trimmed ?? ''),
    queryFn: ({ signal }) => {
      if (!trimmed) {
        throw new Error('Place search query is required')
      }
      return resolvePlaceSearch(trimmed, undefined, signal)
    },
    enabled: !!trimmed && enabled,
    staleTime: Infinity,
    retry: false,
  })
}

export default usePlaceSearchHoverResolve
